import { createRouter, createWebHistory } from 'vue-router'
import ResultsView from '../components/ResultsView.vue'
import LiveResultsView from '../components/LiveResultsView.vue'
import SplitsView from '../components/SplitsView.vue'
import ArResultsView from '../components/ArResultsView.vue'
import StatsView from '../components/StatsView.vue'
import RunnerStatsView from '../components/RunnerStatsView.vue'
import LoopsView from '../components/LoopsView.vue'

const routes = [
  {
    path: '/:eventAlias',
    name: 'Results',
    component: ResultsView
  },
    {
        path: '/live/:eventAlias',
        name: 'LiveResults',
        component: LiveResultsView
    },
    {
        path: '/splits/:eventAlias',
        name: 'Splits',
        component: SplitsView
    },
    {
        path: '/ar/:eventAlias',
        name: 'ArResults',
        component: ArResultsView
    },
    {
        path: '/stats/:eventAlias',
        name: 'Stats',
        component: StatsView
    },
    {
        path: '/stats/:eventAlias/:runnerNumber',
        name: 'RunnerStats',
        component: RunnerStatsView
    },
    {
        path: '/loops/:eventAlias',
        name: 'Loops',
        component: LoopsView
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router